import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { SelectedProductService } from '../main-content/sevices/selected-product.service';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit {
  public allCarttems: any = [];
  public ImagePath
  constructor(private router: Router, private selectedProductService: SelectedProductService, private cdr: ChangeDetectorRef) { }
  public TotalOfAllItems = 0;
  ngOnInit(): void {

    setTimeout(() => {
     
    this.allCarttems = this.selectedProductService.items;
    // this.allCarttems.forEach(element => {
    //   this.ImagePath = element.productImage.imagepath
    // });
        this.getTotal();
   
    }, 100);
 
  
  }
  remove(currentItem) {
    if (this.allCarttems.length > 0) {
      this.selectedProductService.remove(currentItem);
      this.allCarttems = this.selectedProductService.items;
      this.getTotal();
    }
  }
  getTotal() {
    debugger;
    this.TotalOfAllItems = 0;
    this.allCarttems.forEach(element => {
      this.TotalOfAllItems += parseFloat(element.Cost || element.productprice) * parseInt(element.selectedQuantity);
    });

 

    this.cdr.detectChanges();
  }
  updateCart(type, item) {
    if (type == "plus") {
      item.selectedQuantity = item.selectedQuantity + 1;
    } else {
      if (item.selectedQuantity >= 2)
        item.selectedQuantity = item.selectedQuantity - 1;
    }
    this.getTotal();

  }
  purchaseItems() {
    this.selectedProductService.syncItemsWithItems(this.allCarttems);
    this.router.navigateByUrl("/checkout");
  }
}
